import { useId } from 'react'
import { Asset, Maybe, Story } from '@/interfaces/schema'

import IconWithTitle from '@/components/icon-with-title'
import Section from '@/layouts/section'
import { GRID, routes } from '@/lib/constants'
import { ButtonLinkQuartiary } from '@/components/button'
import StoryCardWithImage from '@/components/cards/stories/with-image'
import { StoryCardWithImgPosition } from '@/interfaces/stories'

interface StoriesCardsSectionProps {
  storiesCardsSectionIcon?: Asset
  storiesCardsSectionTitle?: string
  storiesCardsListCollection?: { items?: Array<Maybe<Story>> }
  storiesCardsSectionMoreButtonText?: string
  storiesCardsSectionMoreButtonPath?: string
  id?: string
}

const StoriesCardsSection = ({
  storiesCardsSectionIcon,
  storiesCardsSectionTitle,
  storiesCardsListCollection,
  storiesCardsSectionMoreButtonText,
  storiesCardsSectionMoreButtonPath,
  id = '',
}: StoriesCardsSectionProps) => {
  const storyCardId = useId()

  return (
    <Section id={id} className={`${GRID} mb-[30px] lg:mb-[120px]`}>
      <IconWithTitle
        icon={storiesCardsSectionIcon}
        title={storiesCardsSectionTitle}
      />
      {storiesCardsListCollection?.items?.map((item, index) => {
        const { slug, description, title, image } = item

        return (
          <StoryCardWithImage
            imgPosition={StoryCardWithImgPosition.TOP}
            image={image}
            key={`${storyCardId}-${index}`}
            className="col-span-full md:col-span-3 lg:col-span-4"
            publicationDate={item.publicationDate as Date}
            buttonLink={`${routes.rvdb.knowledgeAndInspiration}/${slug}`}
            description={description}
            title={title}
          />
        )
      })}
      <ButtonLinkQuartiary
        className="col-span-full ml-auto"
        version="a"
        href={storiesCardsSectionMoreButtonPath}
      >
        {storiesCardsSectionMoreButtonText}
      </ButtonLinkQuartiary>
    </Section>
  )
}

export default StoriesCardsSection
